<button style="opacity: 0.6;"
        class="w-auto h-auto p-1 lh-1"
        type="button"
        mat-icon-button
        mat-dialog-close
        [disabled]="disabled">
  <mat-icon>close</mat-icon>
</button>